<template>
  <div class="container-fluid">
    <div class="row">
      <div class="col s3">
        <label>Region / Department / Complex</label>
      </div>
      <div class="col s3">
        <label>Visibility</label>
      </div>
    </div>

    <div v-for="(region, index) in sortedRegions" v-bind:key="index">
      <div class="row no-margin" v-if="region !== null && alarmsettings && alarmsettings !== undefined && alarmsettings !== null">
        <div class="col s3">
          <a class="clickable" @click="addOrRemoveTreeviewOpenRegions(region.RegionId)">
            <i class="material-icons inline-icon" style="margin-top: 6px">{{ (treeview.openRegionIds.includes(region.RegionId) ? 'keyboard_arrow_down' : 'keyboard_arrow_right') }}</i>
            {{ region.Name }}
          </a>
        </div>
        <div>
          <label>
            <input :id="region.RegionId" type="checkbox" @click="setRegion(region.RegionId)" :checked="(alarmsettings.RegionIds.includes(region.RegionId) ? 'checked' : false)" />
            <span></span>
          </label>
        </div>
      </div>

      <div v-for="(department, index) in region.Departments" v-bind:key="index">
        <div class="row no-margin" v-if="treeview.openRegionIds.includes(region.RegionId)">
          <div class="col s3" style="margin-left: 12px">
            <a class="clickable" @click="addOrRemoveTreeviewOpenDepartments(department.DepartmentId)">
              <i class="material-icons inline-icon" style="margin-top: 6px">{{ (treeview.openDepartmentIds.includes(department.DepartmentId) ? 'keyboard_arrow_down' : 'keyboard_arrow_right') }}</i>
              {{ department.Name }}
            </a>
          </div>
          <div>
            <label>
              <input :id="region.RegionId" type="checkbox" @click="setDepartment(department.DepartmentId)" :checked="(alarmsettings.DepartmentIds.includes(department.DepartmentId) ? 'checked' : false)" />
              <span></span>
            </label>
          </div>
        </div>

        <div v-for="(complex, index) in department.Complexes" v-bind:key="index">
          <div class="row no-margin" v-if="treeview.openDepartmentIds.includes(department.DepartmentId) && treeview.openRegionIds.includes(region.RegionId)">
            <div class="col s3" style="margin-left: 36px">
              {{ complex.Name }}
            </div>
            <div>
              <label>
                <input :id="region.RegionId" type="checkbox" @click="setComplex(complex.ComplexId)" :checked="(alarmsettings.ComplexIds.includes(complex.ComplexId) ? 'checked' : false)" />
                <span></span>
              </label>
            </div>
          </div>
        </div>
      </div>

    </div>

  </div>
</template>

<script>
import _ from 'lodash'

export default {
  props: {
    user: Object,
    regions: Array,
    alarmsettings: Object
  },
  data: function () {
    return {
      treeview: {
        openRegionIds: [],
        openDepartmentIds: []
      }
    }
  },
  computed: {
    sortedRegions: function () {
      return _.orderBy(this.regions, ['Name'], ['asc'])
    }
  },
  methods: {
    setRegion: function (regionId) {
      if (this.alarmsettings !== null) {
        if (this.alarmsettings.RegionIds.includes(regionId)) {
          this.alarmsettings.RegionIds.splice(this.alarmsettings.RegionIds.indexOf(regionId), 1)
        } else {
          this.alarmsettings.RegionIds.push(regionId)
        }
      }
    },
    setDepartment: function (deparmentId) {
      if (this.alarmsettings.DepartmentIds.includes(deparmentId)) {
        this.alarmsettings.DepartmentIds.splice(this.alarmsettings.DepartmentIds.indexOf(deparmentId), 1)
      } else {
        this.alarmsettings.DepartmentIds.push(deparmentId)
      }
    },
    setComplex: function (complexId) {
      if (this.alarmsettings.ComplexIds.includes(complexId)) {
        this.alarmsettings.ComplexIds.splice(this.alarmsettings.ComplexIds.indexOf(complexId), 1)
      } else {
        this.alarmsettings.ComplexIds.push(complexId)
      }
    },
    addOrRemoveTreeviewOpenRegions: function (regionId) {
      if (this.treeview.openRegionIds.includes(regionId)) {
        this.treeview.openRegionIds.splice(this.treeview.openRegionIds.indexOf(regionId), 1)
      } else {
        this.treeview.openRegionIds.push(regionId)
      }
    },
    addOrRemoveTreeviewOpenDepartments: function (departmentId) {
      if (this.treeview.openDepartmentIds.includes(departmentId)) {
        this.treeview.openDepartmentIds.splice(this.treeview.openDepartmentIds.indexOf(departmentId), 1)
      } else {
        this.treeview.openDepartmentIds.push(departmentId)
      }
    }
  }
}
</script>

<style scoped>
.inline-icon {
   vertical-align: bottom;
}

[type="checkbox"]:not(:checked), [type="checkbox"]:checked {
    position: fixed !important;
    opacity: 0;
    pointer-events: none;
}
</style>



// WEBPACK FOOTER //
// src/pages/users/_Notificiations.vue